/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import "./hero-image-caption.module.css";

export const HeroImageCaption = ({ story }) => {
  const caption = story["hero-image-caption"];
  const attribution = story["hero-image-attribution"];

  if (!caption && !attribution) return null;
  return (
    <div styleName="wrapper">
      <span data-testid="caption" dangerouslySetInnerHTML={{ __html: caption }} />
      {caption && attribution && <span styleName="divider">|</span>}
      <span data-testid="attribute" dangerouslySetInnerHTML={{ __html: attribution }} />
    </div>
  );
};

HeroImageCaption.propTypes = {
  story: PropTypes.object.isRequired
};
